export const reviewData = [
    {
        review: 'Great place to chill out with friends. Good and Hygenic food.', person:'Raju Timalsina'
    },
    {
        review: 'I loved the aesthetic and ambience of the place.', person:'Suraj Timalsina'
    },
    {
        review: 'Come to have one of the most refreshing tandoori chiya in town.', person:'Abhisek Poudel'
    },
];